// extracted by mini-css-extract-plugin
export default {"root":"SectionLiveRooms_root__A4i9e","header":"SectionLiveRooms_header__2Sk2E","title":"SectionLiveRooms_title__KpY9J","liveRooms":"SectionLiveRooms_liveRooms__vGDpS"};